import { ActionMenu, ItemMenu } from "./../../../models/model";
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { Model } from "../../../models/state/model";
import { Survey } from "src/app/modules/surveys/state/survey.model";
import { Chat } from "src/app/modules/chats/state/chat.model";

@Component({
  selector: "app-table-actions",
  templateUrl: "./table-actions.component.html",
  styleUrls: ["./table-actions.component.scss"],
  standalone: false,
})
export class TableActionsComponent implements OnInit, OnChanges {
  @Output() actions: EventEmitter<ActionMenu> = new EventEmitter();
  @Input() selected: string;
  @Input() itemsMenu: ItemMenu[] = [];
  @Input() target: Model | Survey | Chat;

  action: ActionMenu = {
    name: "",
    editable: false,
    target: {},
  };

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selected?.currentValue !== this.action.target.uuid) {
      this.action.editable = false;
    }
  }

  ngOnInit(): void {
    let [item] = this.itemsMenu.filter((item) =>
      item.name.toLowerCase().includes("delete"),
    );
    if (item) {
      this.itemsMenu.push(
        this.itemsMenu.splice(this.itemsMenu.indexOf(item), 1).pop(),
      );
    }
  }

  setActions(name: string, edit: boolean) {
    this.action.name = name;
    this.action.target = this.target;
    this.action.editable = edit;
    this.actions.emit(this.action);
  }
}
